import { ProductBuilderSelection } from "../../src/types/ProductBuilderTypes";
import { MpvOption } from "../../src/types/ContentfulTypes";
import { getColorsFromUrl } from "./urlHelper";
import { isEmpty } from "lodash";
import { SelectionType } from "../../src/types/DesignOptionTypes";

export default class Colors {
  public static getHyphenatedColorName(colorName?: string) {
    return colorName
      ? colorName.replace(/([a-z][A-Z])/g, (m: string) => `${m[0]}-${m[1].toLowerCase()}`)
      : undefined;
  }
  public static startCase(colorName: string) {
    return colorName.replace(/(^|\s)[^\s]/g, match => match.toUpperCase());
  }
}
const getColorForSwatches = (locale: string): ProductBuilderSelection | null => {
  const colors = getColorsFromUrl(locale);
  if (colors && colors.options && !isEmpty(colors.options)) {
    colors?.options.forEach(option => {
      option.name = Colors.startCase(option.name);
    });
    return {
      selectionStyle: SelectionType.SWATCHES,
      property: colors as MpvOption,
    };
  }
  return null;
};

export { getColorForSwatches };
